import React from 'react';

export const Nivaliz = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='15'
            height='12'
            viewBox='0 0 15 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M11.4316 1.08496C11.5912 1.03964 11.75 1.16022 11.75 1.32617V10.6738C11.75 10.8398 11.5912 10.9604 11.4316 10.915L6.43164 9.48633C6.32444 9.4557 6.25017 9.35755 6.25 9.24609V2.75391C6.25017 2.64245 6.32444 2.5443 6.43164 2.51367L11.4316 1.08496Z'
                stroke='currentColor'
                stroke-width='1.5'
            />
            <path
                d='M13.5 3.25C13.5 2.83579 13.8358 2.5 14.25 2.5C14.6642 2.5 15 2.83579 15 3.25V8.75C15 9.16421 14.6642 9.5 14.25 9.5C13.8358 9.5 13.5 9.16421 13.5 8.75V3.25Z'
                fill='currentColor'
            />
            <path
                d='M0 3.25C0 2.83579 0.335786 2.5 0.75 2.5C1.16421 2.5 1.5 2.83579 1.5 3.25V8.75C1.5 9.16421 1.16421 9.5 0.75 9.5C0.335786 9.5 0 9.16421 0 8.75V3.25Z'
                fill='currentColor'
            />
            <path
                d='M3.56836 1.08496C3.40879 1.03964 3.25 1.16022 3.25 1.32617V10.6738C3.25 10.8398 3.40879 10.9604 3.56836 10.915L8.56836 9.48633C8.67556 9.4557 8.74983 9.35755 8.75 9.24609V2.75391C8.74983 2.64245 8.67556 2.5443 8.56836 2.51367L3.56836 1.08496Z'
                stroke='currentColor'
                stroke-width='1.5'
            />
        </svg>
    );
};

export default Nivaliz;
